var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPinFilled = function SvgPinFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.82843C7 4.29799 7.21071 3.78929 7.58579 3.41421L8.41421 2.58579C8.78929 2.21071 9.29799 2 9.82843 2H14.1716C14.702 2 15.2107 2.21071 15.5858 2.58579L16.4142 3.41421C16.7893 3.78929 17 4.29799 17 4.82843V11.3944C17 11.7893 17.1169 12.1753 17.3359 12.5038L18.7422 14.6132C18.9103 14.8654 19 15.1617 19 15.4648V15.4648C19 16.3127 18.3127 17 17.4648 17H6.53518C5.68733 17 5 16.3127 5 15.4648V15.4648C5 15.1617 5.08971 14.8654 5.25783 14.6132L6.6641 12.5038C6.88312 12.1753 7 11.7893 7 11.3944V4.82843Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17V22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPinFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin-filled.8ac642327b0ec4668f451f51565d8733.svg";